import { useState } from "react";
import { Heading, Muted } from "@/components/typography";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { settings } from "@/lib/settings";

export function NameGate({ onSaved }: { onSaved: () => void }) {
  const [name, setName] = useState("");

  function submit() {
    const trimmed = name.trim();
    if (!trimmed) return;
    settings.setScannerName(trimmed);
    onSaved();
  }

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-4">
        <Heading as="h1" variant="h4">
          Name this scanner
        </Heading>
        <Muted>Identifies this device's uploads. Cannot be changed later.</Muted>
        <Input
          autoFocus
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={e => e.key === "Enter" && submit()}
          placeholder="e.g. Front desk phone"
        />
        <Button className="w-full" disabled={!name.trim()} onClick={submit}>
          Save
        </Button>
      </div>
    </div>
  );
}
